import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent} from 'react';
import './styles.sass';

type ALIGN_TYPE = 'left' | 'right';
export interface IConfirmModalContentProps {
  className?: string;
  children?: any;
  align?: ALIGN_TYPE;
}

export const ConfirmModalContent: StatelessComponent<IConfirmModalContentProps> = ({
  className,
  children,
  align,
}: IConfirmModalContentProps) => {
  const classes = classNames('confirm-modal-content', className, {
    [`confirm-modal-content_${align}`]: align,
  });

  return (
    <div className={classes}>
      {children}
    </div>
  );
};
